(function () {
  'use strict';
  
  /**
   * @ngdoc service
   * @name patdocs.factory:Patdocs
   *
   * @description
   *
   */
  angular
    .module('vcpatdocs')
    .factory('Patdocs', Patdocs);
  
  
  Patdocs.$inject = ['restmod'];
  function Patdocs(restmod) {
    return restmod.model('/routes/patdocs').mix({
      created: {
        init: function () {
          return moment().toISOString();
        }
      },
      active: {init: true},
      $extend: {
        Model: {
          $searchahead: function (_params) {
            return this.$collection().$decorate({
              'before-request': function (_req) {
                _req.method = 'GET';
                _req.url = '/routes/patdocs/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
         /* $aggregate: function (_params) {
            console.log('##### restmod aggregate this: ', this);
            console.log('##### restmod aggregate _params: ', _params);
            return this.$record().$decorate({
              'before-request': function (_req) {
                _req.method = 'POST';
                _req.url = '/routes/patdocs/aggregate';
              }
            }, function () {
              return this.$fetch(_params);
            });
          },*/
          $searchBy: function (key, val) {
            let realquery = {};
            realquery[key] = val;
            return this.$search(realquery);
          }
        } // Model
      }// extend
    });
  }
  
// klammerfriedhof
}());
